import { render, staticRenderFns } from "./KalustoTyypitView.vue?vue&type=template&id=da0befc8&scoped=true"
import script from "./KalustoTyypitView.vue?vue&type=script&lang=js"
export * from "./KalustoTyypitView.vue?vue&type=script&lang=js"
import style0 from "./KalustoTyypitView.vue?vue&type=style&index=0&id=da0befc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0befc8",
  null
  
)

export default component.exports